<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        v-if="activeOrder"
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <page-title :title="$t('confirm_order')" />
          <div
            v-if="mode.isTakeaway || mode.isDelivery"
            class="mt-1 mb-3"
          >
            <takeaway-timer :editable="false" />
          </div>
          <div
            v-if="mode.isDelivery"
            class="mt-1 mb-3"
          >
            <address-selector :editable="false" />
            <delivery-remarks v-if="address.remarks || address.cutlery" :editable="false"/>
          </div>
          <div
            v-if="(mode.isTakeaway || mode.isDelivery) && !isMember && !guestDetailsStatus.isEmpty"
            class="mt-1 mb-3"
          >
            <guest-details />
          </div>
          <div>
            <div
              v-for="item in cart"
              :key="item.cart_id"
            >
              <checkout-item :item="item" />
            </div>
          </div>
          <div>
            <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          </div>
          <div v-if="activeOrder">
            <v-layout row>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                Subtotal
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ activeOrder.sub_total }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="mode.isDelivery && activeOrder.delivery_total && hasDeliveryDiscount"
              row
            >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                {{ deliveryTitle }}
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                style="text-decoration: line-through;"
                :style="nameStyle"
              >
                ${{ parseFloat(deliveryInfo.delivery_plu.before_discount).toFixed(2) }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="mode.isDelivery && activeOrder.delivery_total"
              row
            >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                {{ hasDeliveryDiscount ? deliveryDiscountTitle : deliveryTitle }}
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ activeOrder.delivery_total }}
              </v-flex>
            </v-layout>
            <v-layout
              v-if="discountTotal !== 0 || discountInfoIsFilled"
              row
            >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                {{ discountTitle }}
                <span
                  v-if="discountInfo.promo_code"
                  :style="removeStyle"
                  @click="removeDiscount"
                > {{ $t('remove') }}</span>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ activeOrder.discount_total }}
              </v-flex>
            </v-layout>
            <v-layout v-if="activeOrder.svc_total!='$0.00'" row>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                SVC
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ activeOrder.svc_total }}
              </v-flex>
            </v-layout>
            <v-layout v-if="activeOrder.gst_total!='$0.00'" row >
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
                :style="nameStyle"
              >
                GST
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
                :style="nameStyle"
              >
                {{ activeOrder.gst_total }}
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex
                xs9
                sm9
                md9
                lg10
                xl10
                text-xs-right
              >
                <h3 :style="nameStyle">Total</h3>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                lg2
                xl2
                text-xs-right
              >
                <h3 :style="nameStyle">{{ $n(total, 'currency') }}</h3>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="hasVouchers && (displayVouchersTo.all || displayVouchersTo.members) && isMember">
            <use-vouchers />
          </div>
          <div v-if="allowPoints">
            <use-points />
          </div>
          <use-promo-code />
          <div v-if="parseFloat(activeOrderPayments.topay_payment) > 0 && (mode.paymentMode === 0 && allPaymentModesLength > 1)">
            <v-divider class="mt-1" :color="theme.orders_divider_color" />
            <h3
              class="mb-2 mt-3"
              :style="mySubtitleStyle"
            >{{ $t('select_payment_mode') }}</h3>
            <span v-if="activeOrderPayments.points === 0">
              <v-layout
                row
                align-center
                v-for="p in noPaymentModes"
                :key="p.code"
              >
                <v-flex
                  xs12
                  sm8
                  md6
                  lg4
                  xl3
                >
                  <v-btn
                    flat
                    :color="theme.orders_name_color"
                    :style="paymentModeBtnStyle(p.code)"
                    @click="setPaymentMode(p, 'noPayment')"
                  >
                    <v-icon>{{ p.icon }}</v-icon>
                    <span class="payment-option">{{ $t(p.title) }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </span>
            <v-layout
              row
              align-center
              v-for="p in paymentModes"
              :key="p.code"
            >
              <v-flex
                xs12
                sm8
                md6
                lg4
                xl3
              >
                <template v-if="paymentTypes[p.code].mode === 'apple_pay'">
                  <v-btn
                    v-if="isShowApplePayButton"
                    flat
                    :color="theme.orders_name_color"
                    :style="paymentModeBtnStyle(p.code)"
                    @click="setPaymentMode(p, 'payment')"
                    id="apple-pay-button"
                  >
<!--                    <v-icon>{{ paymentTypes[p.code].icon }}</v-icon>-->
<!--                    <span class="payment-option">{{ $t(paymentTypes[p.code].title) }}</span>-->
                  </v-btn>
<!--                    <div id="apple-pay-button" @click="applePayButtonClicked()"></div>-->
<!--                    <div>1234</div>-->
                </template>
                <template v-else>
                  <v-btn
                    flat
                    :color="theme.orders_name_color"
                    :style="paymentModeBtnStyle(p.code)"
                    @click="setPaymentMode(p, 'payment')"
                  >
                    <v-icon>{{ paymentTypes[p.code].icon }}</v-icon>
                    <span class="payment-option">{{ $t(paymentTypes[p.code].title) }}</span>
                  </v-btn>
                </template>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
      <v-card
        v-else
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <page-title :title="$t('confirm_order')" />
          <div>
            <h3 :style="nameStyle">{{ $t('basket_empty') }}</h3>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <menu-item-dialog v-if="menuItemDialog && !(iOS && inIframe)" from-promo-items-dialog from-checkout />
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import CheckoutItem from '~/components/CheckoutItem'
import TakeawayTimer from '~/components/TakeawayTimer'
import AddressSelector from '~/components/AddressSelector'
import GuestDetails from '~/components/GuestDetails'
import UsePoints from '~/components/UsePoints'
import UseVouchers from '~/components/UseVouchers'
import UsePromoCode from '~/components/UsePromoCode'
import DeliveryRemarks from '../components/DeliveryRemarks'
import axios from 'axios'
import MenuItemDialog from '../components/MenuItemDialog'
import apple_pay from '../mixins/apple_pay'

export default {
  name: 'checkout-view',
  mixins: [apple_pay],
  metaInfo () {
    return { title: this.$t('checkout') }
  },
  components: {
    'page-title': PageTitle,
    'checkout-item': CheckoutItem,
    'takeaway-timer': TakeawayTimer,
    'address-selector': AddressSelector,
    'guest-details': GuestDetails,
    'use-points': UsePoints,
    'use-vouchers': UseVouchers,
    'use-promo-code': UsePromoCode,
    'delivery-remarks': DeliveryRemarks,
    'menu-item-dialog': MenuItemDialog
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'gid', 'mode', 'paymentModes', 'noPaymentModes',
      'posType', 'paymentTypes', 'enableZeroPrice', 'enableMemberPoints', 'pointsPaymentId',
      'allPaymentModesLength', 'displayVouchersTo', 'iOS', 'inIframe', 'restaurant'
    ]),
    ...mapGetters('member', [
      'points', 'isMember'
    ]),
    ...mapGetters('voucher', [
      'discounts'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartAmount', 'cartQty', 'guestDetailsStatus', 'discountInfo',
      'discountInfoIsFilled', 'remarks'
    ]),
    ...mapGetters('order', [
      'activeOrder', 'paymentMode', 'activeOrderPayments'
    ]),
    ...mapGetters('delivery', [
      'deliveryInfo', 'address'
    ]),
    ...mapGetters('menu', [
      'menuItemDialog'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    mySubtitleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    subtotalStyle () {
      return {
        textAlign: 'right',
        marginTop: '20px'
      }
    },
    removeStyle () {
      return {
        cursor: 'pointer',
        color: this.theme.trashcan_color,
        fontSize: '13px',
        textTransform: 'uppercase'
      }
    },
    deliveryTitle () {
      let deliveryTitle = 'Delivery'
      const deliveryPlu = this.deliveryInfo.delivery_plu
      if (deliveryPlu && deliveryPlu.delivery_title && deliveryPlu.delivery_title.toLowerCase() !== 'delivery'){
        deliveryTitle = deliveryPlu.delivery_title
      }
      if (deliveryPlu && deliveryPlu.item_name && deliveryPlu.item_name.toLowerCase() !== 'delivery') {
        deliveryTitle += ' (' + deliveryPlu.item_name + ')'
      }
      return deliveryTitle
    },
    discountTitle () {
      let discountTitle = 'Discount'
      let appliedDiscountInfo = null
      if (this.discountInfoIsFilled || this.mode.hasPresetDiscount) {
        appliedDiscountInfo = parseFloat(this.discountInfo.discount_amount || 0) > parseFloat(this.mode.presetDiscount.discount_amount || 0)
          ? ((this.formatDiscountTitle(parseFloat(this.discountInfo.discount_amount), this.discountInfo.discount_type)) || this.discountInfo.promo_code)
          : discountTitle + ' ' + parseFloat(this.mode.presetDiscount.discount_amount) + '%'
      }
      return !appliedDiscountInfo ? discountTitle : appliedDiscountInfo
    },
    deliveryDiscountTitle () {
      return this.deliveryInfo.delivery_plu.discount_percentage ? 'After ' + this.deliveryInfo.delivery_plu.discount_percentage + '% Delivery Discount' : 'After Delivery Discount'
    },
    discountTotal () {
      if (this.activeOrder && this.activeOrder.discount_total && (this.discountInfoIsFilled || this.mode.hasPresetDiscount)) {
        return parseFloat(this.activeOrder.discount_total.replace(/[^\d.-]/g, ''))
      }
      return 0
    },
    total () {
      if (!this.activeOrder) return 0
      return parseFloat(this.activeOrder.payable_amount) + parseFloat(this.activeOrder.payments_discount)
    },
    allowPoints () {
      if (this.posType === 0 && this.isMember && this.paymentModes.length > 0) {
        if (!this.points || !this.enableMemberPoints || !this.pointsPaymentId) return false
        if (parseFloat(this.points) > 0 && this.total > 0) return true
      }
      return false
    },
    hasVouchers () {
      return this.posType === 0 && this.discounts && this.discounts.length > 0
    },
    hasDeliveryDiscount () {
      return this.deliveryInfo.delivery_plu && this.deliveryInfo.delivery_plu.before_discount && parseInt(this.deliveryInfo.delivery_plu.before_discount) !== parseInt(this.deliveryInfo.delivery_plu.plu_price)
    }
  },
  methods: {
    formatDiscountTitle (discount_amount, discount_type) {
      let discountTitle = 'Discount'
      if (discount_type === 'Price') {
        return discountTitle + ' S$' + parseFloat(discount_amount)
      } else {
        return discountTitle + ' ' + parseFloat(discount_amount) + '%'
      }
    },
    paymentModeBtnStyle (code) {
      if (this.paymentMode && this.paymentMode.code === code) {
        return {
          backgroundColor: this.theme.address_bg_color,
          borderRadius: '3px',
          color: this.theme.address_text_color
        }
      }
    },
    setPaymentMode (mode, payType) {
      console.log(mode)
      console.log(mode)
      console.log(mode)
      console.log(mode)
      if (mode.code === 'apple_pay') {
        this.setApplePaySession(this.restaurant.restaurant_full_name, this.activeOrder);
      }
      this.$store.dispatch('order/setPaymentMode', { ...mode, payType: payType })
    },
    async removeDiscount () {
      this.$bus.$emit('showFullLoading', true)
      if(this.discountInfo.iorder_promo_code_id && this.discountInfo.iorder_promo_code_id !== '') {
        await this.$store.dispatch('promo/updatePromoCodeStatusToAvailable', this.discountInfo.iorder_promo_code_id)
      }
      this.$store.dispatch('cart/resetDiscountInfo')
      if (this.posType === 0) {
        await this.$store.dispatch('order/checkOrder')
      } else {
        await this.$store.dispatch('order/calculateOrder')
      }
      this.$bus.$emit('showFullLoading', false)
      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('successfully_deleted_promo'),
        noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
      })
    }
  },
  async created () {
    // 选择ApplePay后刷新网页，去掉自动选中ApplePay，人工重选才可初始化ApplePaySession
    if (this.paymentMode && this.paymentMode.code === 'apple_pay') {
      this.$store.dispatch('order/resetPaymentMode');
    }

    // check discount info again, make sure used voucher is not in discountInfo
    if (this.discountInfoIsFilled && this.discountInfo && (!this.discountInfo.iorder_promo_discount_id && !this.discountInfo.iorder_promo_code_id)) {
      if (this.discounts.length === 0) {
        this.$store.dispatch('cart/resetDiscountInfo')
      }
      let q = this.discounts.find(v => v.id === this.discountInfo.bill_member_voucher_id)
      if (q && !q.gems_member_voucher.UnlimitedUse && q.used) this.$store.dispatch('cart/resetDiscountInfo')
    }

    if (this.cartQty === 0) {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    } else if (parseFloat(this.cartAmount) === 0 && !this.enableZeroPrice) {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
    // Set default if only have one payment mode
    if (this.allPaymentModesLength === 1) {
      if (this.noPaymentModes.length > 0) {
        this.setPaymentMode(this.noPaymentModes[0], 'noPayment')
      } else {
        this.setPaymentMode(this.paymentModes[0], 'payment')
      }
    }
    if (this.posType === 1) {
      this.$store.dispatch('order/disableUsePoints')
    }
    if (this.isMember) {
      await this.$store.dispatch('member/fetchProfile')
    }
  }
}
</script>

<style scoped>
.payment-option {
  padding-left: 10px;
  text-transform: capitalize;
}

#apple-pay-button {
  -webkit-appearance: -apple-pay-button;
  -apple-pay-button-type: plain;
  -apple-pay-button-style: black;
  display: inline-block;
  /*width: 150px;*/
  height: 35px;
  vertical-align: middle;
  margin-left: 5px
}
</style>



// WEBPACK FOOTER //
// src/pages/checkout.vue